export default __webpack_public_path__ + "static/media/TusharKansara.b3fecb46.png";